// import { env } from 'constant/ua.js'
import { env } from '../../constant/ua';

/**
 * Check webview container user-agent type
 * @param {string} ua webview container user-agent
 * @return {string} default unknown
 */
function main (ua = window.navigator.userAgent) {
  const unk = 'unknown';
  if (typeof ua !== 'string') {
    return unk;
  }
  const lowerUa = ua.toLowerCase();
  let len = env.length;
  while (len > 0) {
    const uaCase = env[len - 1];
    if (uaCase[1].test(lowerUa)) {
      return uaCase[0];
    }
    len--;
  }

  // todo 有些 webview 容器获取 type 不是从 ua 里面获取，可能是 url 中获取，所以这里可以再加一层判断

  return unk;
}

export default main;
